import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/utils/cn';

type LifestyleProtectionBadgeProps = {
    className?: string;
};

export const LifestyleProtectionBadge = ({ className }: LifestyleProtectionBadgeProps) => (
    <Tooltip>
        <TooltipTrigger asChild>
            <span
                aria-label="Claro Lifestyle Protection"
                className={cn('text-cocoa-700 inline-flex h-4 w-4 shrink-0 items-center justify-center', className)}
            >
                <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" aria-hidden="true">
                    <path
                        d="M12 2.5 4 5v6.5c0 4.7 3.3 8.6 8 10 4.7-1.4 8-5.3 8-10V5l-8-2.5Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                    />
                    <text
                        x="12"
                        y="14.5"
                        textAnchor="middle"
                        fontSize="7"
                        fontWeight="700"
                        fill="currentColor"
                        fontFamily="system-ui, sans-serif"
                    >
                        LP
                    </text>
                </svg>
            </span>
        </TooltipTrigger>
        <TooltipContent>Claro Lifestyle Protection</TooltipContent>
    </Tooltip>
);
